/**
 * Focus ring shared by the clickable team cards. The landing tokens expose no
 * Tailwind ring utility, so the CSS variables are referenced directly.
 */
export const CARD_FOCUS_RING =
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-(--landing-cta-light) focus-visible:ring-offset-2 focus-visible:ring-offset-(--landing-bg-primary-purple)";

/** Number of team cards per row in the desktop hanging-card layout. */
export const ROWS_PER_PAGE = 3;
